<template>
  <div>
    <template>
      <v-card class="mx-auto contact-card">
        <v-row class="welcome__header">
          <v-col cols="4">
            <v-img
              alt=""
              cover
              class="home__logo"
              src="@/assets/redcar/logo.png"
              data-cypress-value="logo"
            />
          </v-col>
          <v-col cols="8">
            <h2
              class="home__headline-text black--text"
              data-cypress-value="app-title"
            >
              Target
            </h2>
            <v-img
              alt=""
              contain
              class="arrow"
              src="@/assets/redcar/arrow.png"
            />
            <p
              v-html="translations.home.subtitle"
              class="home__strapline-text"
              data-cypress-value="strapline"
              id="homepage-header"
            ></p>
          </v-col>
        </v-row>

        <div class="introduction">
          <transition name="slide-fade" mode="out-in">
            <div :key="currentHello">
              <h1>{{ currentHello }}</h1>
            </div>
          </transition>
        </div>

        <transition name="slide-fade" mode="out-in">
          <h2 :key="currentHello" id="select-language-heading" class="select__title">{{ select[0] }}</h2>
        </transition>

        <v-container class="px-8">
          <v-row>
            <v-col>
              <fieldset
                class="language-select__radio-group"
                aria-labelledby="select-language-heading"
              >
                <legend class="sr-only">{{ select[0] }}</legend>
                <div
                  v-for="item in langs"
                  :key="item.code"
                  class="language-select__radio-item"
                >
                  <input
                    :id="`lang-radio-${item.code}`"
                    v-model="selectedLang"
                    type="radio"
                    :value="item.code"
                    name="language-select"
                    class="language-select__radio-input"
                    :aria-label="item.name"
                  />
                  <label
                    :for="`lang-radio-${item.code}`"
                    class="language-select__radio-label"
                  >
                    {{ item.name }}
                  </label>
                </div>
              </fieldset>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col class="d-flex justify-center pb-7">
              <v-btn color="primary" dark @click="updateLang(selectedLang)" block>
                {{ continueTranslations[selectedLang] }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </template>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import router from "../router/index.js";

export default {
  data: () => ({
    selectedLang: "en",
    langs: [
      { name: "English", code: "en" },
      { name: "Albanian | Shqiptare", code: "sq" },
      { name: "Amharic | አማርኛ", code: "am" },
      { name: "Arabic | عربي", code: "ar" },
      { name: "Pashto | میل", code: "ps" },
      { name: "Persian | فارسی", code: "fa" },
      { name: "Tigrinya  | ትግርኛ", code: "ti" },
    ],
    hello: [
      "Hello!",
      "Bonjour!",
      "Hola!",
      "أهلا بك",
      "欢迎",
      "Witamy!",
      "Soo dhawow!",
      "Chào mừng!",
    ],
    select: [
      "Please select a language",
      "Veuillez sélectionner une langue",
      "Por favor, seleccione un idioma",
      "يرجى تحديد لغة",
      "请选择一种语言",
      "Proszę wybierz język",
      "Fadlan xulo luuqad",
      "Vui lòng chọn một ngôn ngữ",
    ],
    welcome: [
      "Welcome to the B&NES Care Leavers App The app for B&NES Care Leavers",
      "Bienvenue sur l'application B & NES Care LeaversL'application pour B&NES Care Leavers",
      "Bienvenido a la aplicación Care Leavers de B&NES La aplicación para los que abandonan el cuidado de B&NES",
    ],
    continueTranslations: {
      en: "Continue",
      sq: "Vazhdo",
      am: "መጨረሻ",
      ar: "استمر",
      ps: "ادامه ورکړئ",
      fa: "ادامه دهید",
      ti: "ቀፃሊ",
    },
    currentHello: "Hello!",
  }),
  computed: {
    translations() {
      return hubbdata.getters.translations;
    },
  },
  mounted() {
    localStorage.setItem("enable_font_change", false);
    window.setInterval(() => {
      this.pollPerson();
    }, 5000);
  },
  methods: {
    updateLang(selectedLang) {
      hubbdata.dispatch("updateLang", selectedLang).then(() => {
        hubbdata.dispatch("initDB").then(() => {
          router.push("/terms");
        });
      });
    },
    pollPerson() {
      const first = this.hello.shift();
      this.hello = this.hello.concat(first);
      this.currentHello = this.hello[0];
      const first2 = this.welcome.shift();
      this.welcome = this.welcome.concat(first2);
      const first3 = this.select.shift();
      this.select = this.select.concat(first3);
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-card {
  box-shadow: 0px 0px 0px 0px !important;
  padding-top: 20px;
  padding-bottom: 20px;
}

.introduction {
  padding: 2rem 1rem;
  font-size: 1rem;
  line-height: 1.6;
  text-align: center;
  transition: all 1s;
}

.select__title {
  text-align: center;
  margin-bottom: 20px;
}

.welcome__header {
  align-items: flex-start;
  max-width: 600px;
  width: 100%;
  margin: 0 auto;

  .col-4,
  .col-8 {
    margin: 0;
  }

  .arrow {
    margin-top: 5px;
  }
}

.home {

  &__strapline-text {
    text-align: left;
    font-size: 14px;
    font-weight: 500 !important;
    font-family: "muli", sans-serif !important;
    @media (min-width: 450px) {
      font-size: 18px;
    }
  }
  &__headline-text {
    color: black !important;
    text-align: right;
    font-size: 30px;
    line-height: 30px;
    margin-right: 25px;
    font-weight: 900 !important;
    font-family: "muli", sans-serif !important;
    @media (max-width: 350px) {
      font-size: 25px;
      line-height: 25px;
    }
  }
  &__logo {
    margin: 10px !important;

    margin-right: auto;
    margin-left: auto;
    @media (min-width: 600) {
      margin: 5px;
    }
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.language-select {
  &__radio-group {
    border: 0;
    padding: 0;
    margin: 0;
    min-width: 0;
  }

  &__radio-item {
    border-top: 1px solid $primary;
    margin-bottom: 0 !important;
    position: relative;

    &:last-of-type {
      border-bottom: 1px solid $primary;
    }
  }

  &__radio-input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
    opacity: 0;



    &:focus-visible + .language-select__radio-label {
      outline: 2px solid $primary;
      outline-offset: 2px;
    }
  }

  &__radio-label {
    display: block;
    color: $black !important;
    cursor: pointer;
    padding: 12px;
    margin: 0;



  }

  &__radio-input:checked + .language-select__radio-label {
    background-color: $primary;
    color: $white !important;
  }
}

p {
  font-size: 1.6rem;
  padding-left: 1rem;
}

.home__logo {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.slide-fade-enter-active {
  transition: all 0.8s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s;
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(0px);
  opacity: 0;
}
</style>